import React from 'react'
import HamburgerMenu from 'react-hamburger-menu'
import { useStoreActions, useStoreState } from 'easy-peasy'

import { Box, Flex, Grid, Text, Button, SVG, Link } from 'system'
import { BoundedBox } from '../components/BoundedBox'
import { ReactComponent as BookIconSVG } from '../assets/icon-book.svg'
import { ReactComponent as SignoutIconSVG } from '../assets/icon-signout.svg'
import { Search } from './Search'

export const Header = props => {
  const isNavOpen = useStoreState(state => state.nav.isNavOpen)
  const { toggleNav, logoutUser } = useStoreActions(actions => ({
    toggleNav: actions.nav.toggleNav,
    logoutUser: actions.auth.logoutUser,
  }))

  return (
    <Box
      as="header"
      bg="purple.100"
      color="black"
      borderBottom="1px solid"
      borderColor="purple.90"
      position="relative"
      zIndex={51}
      py={[1, 2]}
      {...props}
    >
      <BoundedBox py={0}>
        <Grid
          gridTemplateColumns={[
            'auto 1fr auto',
            '1fr 3fr',
            null,
            '1fr 4fr 1fr',
          ]}
          gridGapScale="l"
        >
          <Flex alignItems="center">
            <Link href="/reference/">
              <Flex alignItems="center">
                <SVG
                  x={1}
                  y={1}
                  svg={BookIconSVG}
                  width={['1.25rem', '1.5rem']}
                  fill="purple.50"
                />
                <Text
                  color="purple.50"
                  display={['none', 'block']}
                  fontSize="normal"
                  fontWeight="medium"
                  ml={1}
                >
                  Docs
                </Text>
              </Flex>
            </Link>
          </Flex>
          <Flex
            justifyContent="center"
            alignItems="center"
            maxWidth="small"
            width={1}
            justifySelf="center"
          >
            <Search />
          </Flex>
          <Box
            as={Button}
            display={['block', 'none']}
            alignSelf="center"
            justifySelf="end"
            cursor="pointer"
          >
            <HamburgerMenu
              isOpen={isNavOpen}
              menuClicked={() => toggleNav()}
              width={18}
              height={13}
              color="#8359A6"
            />
          </Box>
          <Flex
            as={Button}
            display={['none', null, null, 'flex']}
            justifySelf="start"
            alignItems="center"
            cursor="pointer"
            onClick={logoutUser}
          >
            <Text
              color="purple.50"
              fontWeight="medium"
              fontSize="small"
              display={['none', 'block']}
            >
              Sign Out
            </Text>
            <SVG
              x={1}
              y={1}
              svg={SignoutIconSVG}
              width="1.25rem"
              fill="purple.50"
              ml={1}
            />
          </Flex>
        </Grid>
      </BoundedBox>
    </Box>
  )
}
